module.exports = __webpack_public_path__ + "static/media/compass_creation.1dc7c925.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PollForm/compass_creation.svg
// module id = 729
// module chunks = 0